import { supabase, throwIfSupabaseError } from "@/lib/supabase"

/**
 * The site's whole Supabase surface. Every function here is defined in this
 * repo's `supabase/migrations/` (backed by the `marketing` schema) — never in
 * the app repo. Add new site data needs there, and expose them from here.
 */

export type WaitlistList = "access_request" | "waitlist"

export interface JoinWaitlistInput {
  email: string
  list: WaitlistList
  name?: string
  company?: string
  role?: string
  useCase?: string
}

/** Returns the raw RPC result so forms can map `email_invalid` etc. themselves. */
export function joinWaitlist(input: JoinWaitlistInput) {
  return supabase.rpc("marketing_join_waitlist", {
    p_email: input.email,
    p_list: input.list,
    p_name: input.name || null,
    p_company: input.company || null,
    p_role: input.role || null,
    p_use_case: input.useCase || null,
  })
}

export async function listPricingPlanRows(): Promise<Record<string, unknown>[]> {
  const result = await supabase.rpc("marketing_list_pricing_plans")
  return throwIfSupabaseError(result) ?? []
}
